<template>
  <v-main class="primary">
    <transition name="fade" mode="out-in">
      <loader-component v-if="loading"></loader-component>
      <router-view v-else></router-view>
    </transition>
  </v-main>
</template>

<script>
import { MODULOS } from '@src/perfiles'
import LoaderComponent from '@src/components/LoaderComponent.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    LoaderComponent,
  },

  async created() {
    this.ENABLE_LOADER()
    this.setThemeByModule(MODULOS.ENLACE)

    this.DISABLE_LOADER()
  },
  computed: {
    ...mapGetters({
      loading: 'getLoader',
    }),
  },
  methods: {
    ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),
  },
}
</script>
